import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { services } from '../mockData';
import { openZendeskChat } from '../utils/zendesk';

export const Header = ({ onOpenPopup }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  const isLpPage = location.pathname === '/lp';

  if (isLpPage) return null;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50" data-testid="main-header">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="header-logo">
            <img 
              src="/assets/images/logo-color.png" 
              alt="Trademark Examining Lawyer" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-testid="desktop-nav">
            <Link to="/" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium" data-testid="nav-home">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium" data-testid="nav-about">
              About Us
            </Link>
            
            {/* Services Mega Menu */}
            <div 
              className="relative"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <button className="flex items-center text-gray-700 hover:text-[#ba2a84] transition-colors font-medium">
                Services
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              
              {servicesOpen && (
                <div className="absolute left-1/2 transform -translate-x-1/2 top-full pt-2 w-80">
                  <div className="bg-white shadow-xl rounded-lg border border-gray-200 py-4">
                    {services.map((service) => (
                      <Link
                        key={service.id}
                        to={`/services/${service.slug}`}
                        className="block px-6 py-3 hover:bg-[#f0d4e0] transition-colors"
                      >
                        <div className="font-medium text-gray-900">{service.title}</div>
                        <div className="text-sm text-gray-600 mt-1">{service.shortDescription}</div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link to="/our-attorneys" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium" data-testid="nav-attorneys">
              Our Attorneys
            </Link>

            <Link to="/contact" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium" data-testid="nav-contact">
              Contact Us
            </Link>
          </nav>

          {/* Right Side Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <button
              onClick={onOpenPopup}
              data-testid="header-register-btn"
              className="px-6 py-2.5 bg-[#ba2a84] text-white rounded-lg hover:bg-[#8a1f63] transition-colors font-medium"
            >
              Register My Trademark
            </button>
            <button 
              onClick={openZendeskChat}
              data-testid="header-chat-btn"
              className="js-chat px-6 py-2.5 border-2 border-[#58225a] text-[#58225a] rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              Chat Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium">
                Home
              </Link>
              <Link to="/about" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium">
                About Us
              </Link>
              <div className="text-gray-700 font-medium">Services</div>
              <div className="pl-4 space-y-3">
                {services.map((service) => (
                  <Link
                    key={service.id}
                    to={`/services/${service.slug}`}
                    className="block text-gray-600 hover:text-[#ba2a84] transition-colors"
                  >
                    {service.title}
                  </Link>
                ))}
              </div>
              <Link to="/our-attorneys" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium">
                Our Attorneys
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-[#ba2a84] transition-colors font-medium">
                Contact Us
              </Link>
              <button
                onClick={onOpenPopup}
                className="px-6 py-2.5 bg-[#ba2a84] text-white rounded-lg hover:bg-[#8a1f63] transition-colors font-medium text-center"
              >
                Register My Trademark
              </button>
              <button 
                onClick={openZendeskChat}
                className="js-chat px-6 py-2.5 border-2 border-[#58225a] text-[#58225a] rounded-lg hover:bg-gray-50 transition-colors font-medium text-center"
              >
                Chat Now
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
